import { render, staticRenderFns } from "./forum.vue?vue&type=template&id=1873c88d&scoped=true"
import script from "./forum.vue?vue&type=script&lang=js"
export * from "./forum.vue?vue&type=script&lang=js"
import style0 from "./forum.vue?vue&type=style&index=0&id=1873c88d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1873c88d",
  null
  
)

export default component.exports